module.exports = __webpack_public_path__ + "static/media/42.8bcf62d2.mp3";